<template>
  <GBox>
    <GBox
      flex
      class="login-wrapper"
    >
      <GBox class="form">
        <LoginForm />
      </GBox>
      <GBox class="announcement">
        <Announcement />
      </GBox>
    </GBox>
    <AnnouncementWidgets class="announcement-widgets" />
  </GBox>
</template>

<script>
import GBox from '@trendyol-js/grace/core/GBox';
import LoginForm from '@/views/LoginNew/LoginForm';
import Announcement from './Announcement';
import AnnouncementWidgets from '@/views/LoginNew/AnnouncementWidgets';
export default {
  name: 'LoginNew',

  components: {
    AnnouncementWidgets,
    LoginForm,
    GBox,
    Announcement,
  },
};
</script>

<style lang="scss" scoped>
.login-wrapper {
  margin-bottom: 20px;

  .form {
    flex: 1;
  }
  .announcement {
    flex: 2;
    width: 50%;
    margin-left: 30px;
  }

  @media only screen and (max-width:767px) {
    flex-direction: column;

    .announcement {
      width: 100%;
      margin-left: 0;
    }

    .announcement, .form {
      width: 100% !important;
    }
  }
}

@media only screen and (min-width: 1025px){
  .announcement-widgets {
    display: none !important;
  }
}

@media only screen and (max-width: 1024px){
  .announcement {
    width: calc(50% - 15px) !important;
  }
}

@media only screen and (max-width: 970px){
  .form {
    flex: 1.6 !important;
  }
}
</style>
